import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, MessageCircle, Plus, RefreshCw, Check, Clock, AlertTriangle, CreditCard, Gift, Trash2, X } from 'lucide-react';
import { toast } from 'react-toastify';
import { nl, errorMsg } from './newsletter.api';

/* WhatsApp del newsletter (pago, USD 10/mes): la desarrolladora escribe su plantilla, Lisual la
   manda a aprobar a Meta y, una vez aprobada, sale a sus inversores desde el número de LisualPro. */

const ESTADO = {
  APPROVED: ['Aprobada por Meta', 'text-emerald-700 bg-emerald-50', Check],
  PENDING: ['En revisión de Meta', 'text-amber-700 bg-amber-50', Clock],
  IN_APPEAL: ['En revisión de Meta', 'text-amber-700 bg-amber-50', Clock],
  REJECTED: ['Rechazada por Meta', 'text-red-700 bg-red-50', AlertTriangle],
  PAUSED: ['Pausada por Meta', 'text-red-700 bg-red-50', AlertTriangle],
  DISABLED: ['Desactivada por Meta', 'text-red-700 bg-red-50', AlertTriangle],
};
const MOTIVOS = { INVALID_FORMAT: 'formato inválido', PROMOTIONAL: 'contenido promocional no permitido', ABUSIVE_CONTENT: 'contenido no permitido', TAG_CONTENT_MISMATCH: 'el texto no coincide con la categoría', SCAM: 'parece engañoso' };
const volver = () => { const u = new URL(window.location.href); ['nl_wa', 'nl_session'].forEach((k) => u.searchParams.delete(k)); return u.toString(); };

function Burbuja({ texto, empresa, boton }) {
  return (
    <div className="rounded-xl p-3" style={{ background: '#e5ddd5' }}>
      <div className="bg-white rounded-lg shadow-sm max-w-[290px] overflow-hidden text-[13px] text-gray-800">
        <div className="h-24 bg-gray-200 flex items-center justify-center text-[11px] text-gray-500">Foto de la obra</div>
        <div className="p-2.5 whitespace-pre-wrap">{texto || 'Tu mensaje…'}</div>
        <div className="px-2.5 pb-1.5 text-[11px] text-gray-400">{(empresa || 'Tu empresa')} · vía Lisual</div>
        <div className="border-t border-gray-100 text-center py-2 text-[#0a7cff] font-semibold">{boton || 'Ver novedades'}</div>
      </div>
    </div>
  );
}

function NuevaPlantilla({ ctx, c, onCreada, onCerrar }) {
  const [texto, setTexto] = useState(`Hola {nombre}, ${c.companyName || ctx.empresa || 'te'} comparte las novedades de ${c.projectName || ctx.obra || 'la obra'} de este mes, con el video del avance. Tocá el botón para verlas.`);
  const [boton, setBoton] = useState('Ver novedades');
  const [prev, setPrev] = useState({ body: '', error: null });
  const [enviando, setEnviando] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => nl.waPreview({ text: texto, companyName: c.companyName, projectName: c.projectName }).then(setPrev).catch(() => {}), 300);
    return () => clearTimeout(t);
  }, [texto, c.companyName, c.projectName]);
  const crear = async () => {
    setEnviando(true);
    try {
      const t = await nl.waCreateTemplate({ customerId: ctx.customerId, feedId: c.feedId || ctx.feedID, companyName: c.companyName, projectName: c.projectName, text: texto, buttonText: boton });
      toast.success('Plantilla enviada a Meta. Suele aprobarse en minutos u horas.');
      onCreada(t);
    } catch (e) { toast.error(errorMsg(e)); }
    setEnviando(false);
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center sm:p-6" onClick={onCerrar}>
      <div className="bg-white w-full sm:max-w-3xl rounded-t-2xl sm:rounded-2xl p-5 space-y-4 max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <div><div className="font-semibold text-gray-900">Nueva plantilla de WhatsApp</div><div className="text-sm text-gray-500">Es el mensaje que reciben tus inversores. Meta la revisa una vez y queda lista para usar en todos tus envíos.</div></div>
          <button type="button" onClick={onCerrar} className="p-2 rounded-lg hover:bg-gray-100 text-gray-500" aria-label="Cerrar"><X size={18} /></button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-[1fr_300px] gap-4">
          <div className="space-y-3">
            <label className="block space-y-1.5">
              <span className="flex justify-between text-xs font-semibold text-gray-700"><span>Mensaje</span><span className="font-normal text-gray-500">{texto.length}/900</span></span>
              <textarea value={texto} onChange={(e) => setTexto(e.target.value)} maxLength={900} className="block w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500" style={{ height: 150 }} />
              <span className="block text-[11px] text-gray-500">Escribí {'{nombre}'} donde va el nombre de cada inversor. Sin links: el mensaje ya lleva un botón al newsletter con el timelapse.</span>
            </label>
            <label className="block space-y-1"><span className="text-xs font-semibold text-gray-700">Texto del botón</span>
              <input value={boton} maxLength={25} onChange={(e) => setBoton(e.target.value)} className="block w-full border border-gray-300 rounded-lg px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" style={{ height: 40 }} /></label>
            {prev.error && <div className="text-xs text-red-700 bg-red-50 rounded-lg px-3 py-2">{prev.error}</div>}
            <div className="text-xs text-gray-600 bg-gray-50 rounded-lg px-3 py-2">Sale desde el WhatsApp oficial de LisualPro, firmado con el nombre de tu empresa. Meta la clasifica como mensaje de marketing.</div>
          </div>
          <Burbuja texto={prev.body} empresa={c.companyName || ctx.empresa} boton={boton} />
        </div>
        <button type="button" disabled={enviando || !!prev.error} onClick={crear} className="w-full inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-50">{enviando ? <Loader2 size={16} className="animate-spin" /> : <MessageCircle size={16} />}<span>Mandar a Meta para aprobar</span></button>
      </div>
    </div>
  );
}

/** Sección WhatsApp del paso "Envío". */
export default function CanalWhatsapp({ c, ctx, cambiar }) {
  const [estado, setEstado] = useState(null);
  const [plantillas, setPlantillas] = useState(null);
  const [nueva, setNueva] = useState(false);
  const [trabajando, setTrabajando] = useState(false);

  const cargar = useCallback(() => {
    nl.waStatus(ctx.customerId).then(setEstado).catch((e) => setEstado({ error: errorMsg(e) }));
    nl.waTemplates(ctx.customerId).then(setPlantillas).catch(() => setPlantillas([]));
  }, [ctx.customerId]);
  useEffect(() => { cargar(); }, [cargar]);

  const pagar = async () => {
    setTrabajando(true);
    try { const r = await nl.waCheckout({ customerId: ctx.customerId, returnUrl: volver(), companyName: c.companyName }); window.location.href = r.url; } catch (e) { toast.error(errorMsg(e)); setTrabajando(false); }
  };
  const cortesia = async () => {
    setTrabajando(true);
    try { await nl.waCortesia({ customerId: ctx.customerId }); toast.success('WhatsApp activado sin cargo para este cliente'); cargar(); } catch (e) { toast.error(errorMsg(e)); }
    setTrabajando(false);
  };
  const portal = async () => { try { const r = await nl.waPortal({ customerId: ctx.customerId, returnUrl: volver() }); window.location.href = r.url; } catch (e) { toast.error(errorMsg(e)); } };

  if (!estado) return <div className="flex items-center gap-2 text-sm text-gray-500"><Loader2 size={15} className="animate-spin" />Cargando WhatsApp…</div>;
  if (estado.error) return <div className="text-sm text-red-700">{estado.error}</div>;

  if (!estado.active) {
    return (
      <div className="rounded-xl border-2 border-dashed border-gray-300 p-4 space-y-3">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0"><MessageCircle size={20} /></div>
          <div className="flex-1"><div className="font-semibold text-gray-900">WhatsApp para tus inversores · USD {estado.priceUsd}/mes</div>
            <div className="text-sm text-gray-500 mt-0.5">Cada newsletter también les llega por WhatsApp, con la foto de la obra y un botón al newsletter completo. El mail sigue siendo gratis.</div></div>
        </div>
        <div className="flex flex-wrap gap-2">
          <button type="button" disabled={trabajando} onClick={pagar} className="inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-60">{trabajando ? <Loader2 size={15} className="animate-spin" /> : <CreditCard size={15} />}<span>Activar WhatsApp</span></button>
          {estado.admin && <button type="button" disabled={trabajando} onClick={cortesia} className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold border border-gray-300 text-gray-700 hover:bg-gray-50"><Gift size={15} /><span>Activar sin cargo (admin Lisual)</span></button>}
        </div>
        <div className="text-[11px] text-gray-500">Pago mensual con tarjeta por Stripe. Lo das de baja cuando quieras.</div>
      </div>
    );
  }

  const aprobadas = (plantillas || []).filter((t) => t.status === 'APPROVED');
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-full"><Check size={12} />WhatsApp activo</span>
        <div className="flex gap-3">
          <button type="button" onClick={cargar} className="inline-flex items-center gap-1 text-xs font-semibold text-gray-600 hover:text-gray-900"><RefreshCw size={12} />Actualizar estado</button>
          {estado.status && estado.status !== 'active' ? null : <button type="button" onClick={portal} className="text-xs font-semibold text-gray-600 hover:text-gray-900">Facturación</button>}
        </div>
      </div>
      <div className="space-y-2">
        <span className="text-xs font-semibold text-gray-700">Mensaje que se manda</span>
        {!plantillas ? <Loader2 size={15} className="animate-spin text-gray-400" /> : !plantillas.length ? (
          <div className="text-sm text-gray-500">Todavía no tenés plantillas. Creá una y mandala a aprobar: Meta suele responder en minutos u horas.</div>
        ) : plantillas.map((t) => {
          const [txt, cls, Ic] = ESTADO[t.status] || [t.status, 'text-gray-600 bg-gray-100', Clock];
          const elegida = c.whatsapp?.template === t.name;
          return (
            <div key={t.id} className={`rounded-xl border p-3 flex gap-3 items-start ${elegida ? 'border-blue-600 bg-blue-50' : 'border-gray-200'}`}>
              <input type="radio" name="wa-tpl" className="mt-1" disabled={t.status !== 'APPROVED'} checked={elegida} onChange={() => cambiar({ whatsapp: { template: t.name } })} aria-label="Usar esta plantilla" />
              <div className="flex-1 min-w-0">
                <span className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full ${cls}`}><Ic size={11} />{txt}</span>
                <div className="text-sm text-gray-800 mt-1.5 whitespace-pre-wrap">{t.text}</div>
                {t.status === 'REJECTED' && <div className="text-xs text-red-700 mt-1">Motivo: {MOTIVOS[t.reason] || t.reason || 'Meta no informó el motivo'}. Probá con otro texto, sin promesas de precio ni mayúsculas.</div>}
              </div>
              <button type="button" onClick={async () => { if (!window.confirm('¿Borrar esta plantilla?')) return; try { await nl.waDeleteTemplate(t.id); if (elegida) cambiar({ whatsapp: { template: null } }); cargar(); } catch (e) { toast.error(errorMsg(e)); } }} className="p-1.5 rounded-lg hover:bg-red-50 text-red-500" aria-label="Borrar plantilla"><Trash2 size={14} /></button>
            </div>
          );
        })}
        {!!plantillas?.length && !aprobadas.length && <div className="text-xs text-amber-700">Cuando Meta apruebe la plantilla la vas a poder elegir. El mail sale igual.</div>}
        <button type="button" onClick={() => setNueva(true)} className="w-full inline-flex items-center justify-center gap-1.5 text-sm font-semibold text-blue-700 border border-dashed border-blue-300 rounded-lg py-2.5 hover:bg-blue-50"><Plus size={15} /><span>Crear plantilla</span></button>
      </div>
      {nueva && <NuevaPlantilla ctx={ctx} c={c} onCerrar={() => setNueva(false)} onCreada={(t) => { setNueva(false); setPlantillas((p) => [t, ...(p || [])]); }} />}
    </div>
  );
}
